import { render, staticRenderFns } from "./ConsentModal.vue?vue&type=template&id=85ff04b8&scoped=true&"
import script from "./ConsentModal.vue?vue&type=script&lang=js&"
export * from "./ConsentModal.vue?vue&type=script&lang=js&"
import style0 from "./ConsentModal.vue?vue&type=style&index=0&id=85ff04b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ff04b8",
  null
  
)

export default component.exports